import React from 'react';
import { render } from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  NavLink,
} from 'react-router-dom';

import Relic from './relic';
import Material from './material';

const App = () => (
  <div className="app header-fixed ">
    <header className="app-header bg-primary">
      <nav className="container h-100 navbar navbar-dark justify-content-center">
        <div className="navbar-nav">
          <NavLink className="nav-item" to="/material">
            <span className="nav-link">加工資源換算ツール</span>
          </NavLink>
          <span className="text-info mx-2">|</span>
          <NavLink className="nav-item" to="/relic">
            <span className="nav-link">木石神器計算ツール</span>
          </NavLink>
        </div>
      </nav>
    </header>
    <div className="app-body pb-5">
      <Switch>
        <Route path="/relic" component={Relic} />
        <Route path="/material" component={Material} />
        <Redirect to="/relic" />
      </Switch>
    </div>
  </div>
);

render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root'),
);
